/**
 * Query params carried on the contract-detail URL when the user arrives from
 * the Notification Center. `EventAlertStack` reads them once on mount and then
 * strips them from the URL, so they are a one-shot handover, not app state.
 */
export const EVENT_SOURCE_PARAM = "eventSource";
export const EVENT_TYPE_PARAM = "eventType";
export const EVENT_DATE_PARAM = "eventDate";
